<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage">
<div class="title_page"><a href="#/nav#ntitle-page"><img alt="title page" id="title-page" src="9780785226161_tpimage.jpg"/></a></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?3df58d04